export const EAS_INFO_SLICE_NAME = '@@easInfo';
